import {FC, useState} from 'react'
import {Clock, Pulldown} from 'jbc-front/components/icons'
import classNames from 'classnames'
import {dateFormat} from 'libs/formatter'
import type {Todo as TodoItem} from 'types/api/todo/todo'
import styles from './Todo.scss'

export type TodoChangeHandler = (todoListNo: number, todoNo: number, todo: TodoItem) => void

interface Props {
  todo: TodoItem
  todoListNo: number
  todoNo: number
  onTodoChange: TodoChangeHandler
}

export const Todo: FC<Props> = ({todo, todoListNo, todoNo, onTodoChange}) => {
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false)
  const handleDescriptionToggle = () => setIsDescriptionOpen((v) => !v)

  const isDone = todo.status === 'done'

  return (
    <div className={styles.todoItem}>
      <div className={styles.todoText}>
        <label className={styles.todoLabel}>
          <input
            type="checkbox"
            onChange={() => onTodoChange(todoListNo, todoNo, todo)}
            checked={isDone}
            className="m-checkbox-input"
          />
          &nbsp;
          <span className={classNames('m-checkbox-parts', isDone ? styles.todoDone : styles.todoWill)}>
            {todo.title}
          </span>
        </label>
        {todo.description && (
          <div
            className={isDescriptionOpen ? styles.todoPulldownShow : styles.todoPulldown}
            onClick={handleDescriptionToggle}
          >
            <Pulldown />
          </div>
        )}
      </div>
      {todo.due_on && (
        <div className={styles.todoListsDate}>
          <Clock size={13} /> {dateFormat(todo.due_on, 'MMMDo')}
        </div>
      )}
      {todo.description && isDescriptionOpen && <div className={styles.todoDescription}>{todo.description}</div>}
    </div>
  )
}
